import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {onboardingGuideRightSideWidth, onboardingGuideSlideHeight} from './onboardingGuideHelpers';

/*
 * Props.
 */

interface OnboardingGuideRightHalfContainerProps {
  children: ReactNode;
}

/*
 * Style.
 */

const StyledOnboardingGuideRightHalfContainerDiv = styled.div`
  width: ${onboardingGuideRightSideWidth};
  height: ${onboardingGuideSlideHeight};
  background: ${(p) => p.theme.greys.shade20};
`;

/*
 * Component.
 */

export const OnboardingGuideRightHalfContainer: FC<OnboardingGuideRightHalfContainerProps> = ({children}) => (
  <StyledOnboardingGuideRightHalfContainerDiv>{children}</StyledOnboardingGuideRightHalfContainerDiv>
);
